import React, { useState } from 'react';
import { Button, Card, CardBody, Col, Container, Form, FormFeedback, Input, Label, Row, Spinner } from 'reactstrap';
import ParticlesAuth from './ParticlesAuth';
import { Link, useNavigate } from 'react-router-dom';
import withRouter from '../.././components/withRouter';

// Formik validation
import * as Yup from 'yup';
import { useFormik } from 'formik';
import logoLight from '../../assets/images/logo-light.png';
import { postLogin } from '../../api/authApi';

const Login = (props: any) => {
    const navigate = useNavigate();
    const [userLogin, setUserLogin] = useState<{ email: string; password: string; rememberMe: boolean }>({ email: '', password: '', rememberMe: false });
    const [passwordShow, setPasswordShow] = useState<boolean>(false);
    const [loader, setLoader] = useState<boolean>(false);

    const validation: any = useFormik({
        enableReinitialize: true,
        initialValues: {
            rememberMe: userLogin.rememberMe,
            email: userLogin.email,
            password: userLogin.password,
        },
        validationSchema: Yup.object({
            email: Yup.string().email('E-mail inválido').required('Por favor, insira seu e-mail'),
            password: Yup.string().required('Por favor, digite sua senha'),
            rememberMe: Yup.boolean(),
        }),
        onSubmit: (values) => {
            setLoader(true);
            postLogin(values)
                .then((res) => {
                    if (res && res.access_token && res.refresh_token) {
                        localStorage.setItem('access_token', res.access_token);
                        localStorage.setItem('refresh_token', res.refresh_token);

                        navigate('/campaign');
                    }
                })
                .catch(() => {})
                .finally(() => {
                    setLoader(false);
                });
        },
    });

    document.title = 'Área Restrita | Ad Pulse';
    return (
        <React.Fragment>
            <ParticlesAuth>
                <div className="auth-page-content mt-lg-5">
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <div className="text-center mt-sm-5 mb-4 text-white-50">
                                    <div>
                                        <Link to="/" className="d-inline-block auth-logo">
                                            <img src={logoLight} alt="" height="60"/>
                                        </Link>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        <Row className="justify-content-center">
                            <Col md={8} lg={6} xl={5}>
                                <Card className="mt-4">
                                    <CardBody className="p-4">
                                        <div className="text-center mt-2">
                                            <h5 className="text-primary">Bem vindo de volta !</h5>
                                            <p className="text-muted">Entre para continuar para Ad Pulse.</p>
                                        </div>
                                        <div className="p-2 mt-4">
                                            <Form
                                                autoComplete="on"
                                                onSubmit={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    validation.handleSubmit();
                                                    return false;
                                                }}
                                                action="#">

                                                <div className="mb-3">
                                                    <Label htmlFor="email" className="form-label">E-mail</Label>
                                                    <Input
                                                        name="email"
                                                        id="email"
                                                        className="form-control"
                                                        type="email"
                                                        autoComplete="email"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.email}
                                                        invalid={
                                                            !!(validation.touched.email && validation.errors.email)
                                                        }
                                                    />
                                                    {validation.touched.email && validation.errors.email ? (
                                                        <FormFeedback
                                                            type="invalid">{validation.errors.email}</FormFeedback>
                                                    ) : null}
                                                </div>

                                                <div className="mb-3">
                                                    <div className="float-end">
                                                        <Link to="/forgot-password" className="text-muted">Esqueceu sua
                                                            senha?</Link>
                                                    </div>
                                                    <Label className="form-label" htmlFor="password-input">Senha</Label>
                                                    <div className="position-relative auth-pass-inputgroup mb-3">
                                                        <Input
                                                            name="password"
                                                            id="password-input"
                                                            value={validation.values.password}
                                                            type={passwordShow ? 'text' : 'password'}
                                                            className="form-control pe-5"
                                                            autoComplete="current-password"
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            invalid={
                                                                !!(validation.touched.password && validation.errors.password)
                                                            }
                                                        />
                                                        {validation.touched.password && validation.errors.password ? (
                                                            <FormFeedback
                                                                type="invalid">{validation.errors.password}</FormFeedback>
                                                        ) : null}
                                                        <button
                                                            className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                                                            type="button"
                                                            id="password-addon"
                                                            onClick={() => setPasswordShow(!passwordShow)}><i
                                                            className="ri-eye-fill align-middle"></i></button>
                                                    </div>
                                                </div>

                                                <div className="form-check">
                                                    <Input className="form-check-input"
                                                           id="rememberMe"
                                                           name="rememberMe"
                                                           type="checkbox"
                                                           value="true"
                                                           onChange={validation.handleChange}
                                                           onBlur={validation.handleBlur}
                                                    />
                                                    <Label className="form-check-label" htmlFor="rememberMe">Lembre-me</Label>
                                                </div>

                                                <div className="mt-4">
                                                    <Button color="success"
                                                            disabled={loader}
                                                            className="btn btn-success w-100" type="submit">
                                                    {loader && <Spinner size="sm"
                                                                            className="me-2"> Carregando... </Spinner>}
                                                        Entrar
                                                    </Button>
                                                </div>

                                                <div className="mt-4 text-center">
                                                    <div className="signin-other-title">
                                                        <h5 className="fs-13 mb-4 title">Entrar com</h5>
                                                    </div>
                                                    <div>
                                                        <Link to={process.env.REACT_APP_API_URL + '/auth/google'}
                                                              className="btn btn-danger btn-icon me-1">
                                                            <i className="ri-google-fill fs-16"/>
                                                        </Link>
                                                        <Link to={process.env.REACT_APP_API_URL + '/auth/microsoft'}
                                                              className="btn btn-info btn-icon me-1">
                                                            <i className="ri-microsoft-fill fs-16"/>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </Form>
                                        </div>
                                    </CardBody>
                                </Card>

                            </Col>
                        </Row>
                    </Container>
                </div>
            </ParticlesAuth>
        </React.Fragment>
    );
};

export default withRouter(Login);